import config from "../../../../config.json";
const AppConfig = {
    themeColors: {
        primary: "#00A9DF",
        secondary: "#e71a46",
        success: "#08D780",
        danger: "#e71a46",
        warning: "#F5A700",
        info: "#00A9DF",
        dark: "#464D69",
        default: "#FAFAFA",
        greyLighten: "#D1D3D4",
        grey: "#545456",
        white: "#FFFFFF",
        blue: "#00A9DF",
        lightblue: "#45C1E9",
        lightestblue: "#A6E1F4",
        red: "#e71a46",
        lightred: "#ffa8ac",
        yellow: "#F8C600",
        green: "#08D780",
    },
    fonts: {
        primary: "Nunito",
    },
    slackScopes: config.slack_scopes,
    env: {
        sentryDSN: process.env["SENTRY_DSN"],
        muiPremiumLicenseKey: process.env["MUI_PREMIUM_LICENSE_KEY"],
        loginUrl: "/auth/login/google-oauth2/",
        version: process.env["VERSION"],
        isDevelopment: process.env["NODE_ENV"] !== "production",
    },
    timezone: "America/New_York",
    rootElement: null,
};
export const CONFIRMATION_DIALOG_DELETE_ITEM_DEFAULT_OPTIONS = {
    title: "Are you sure?",
    description: "You won't be able to undo this action.",
    confirmationText: "Delete",
    confirmationButtonProps: {
        color: "error",
        variant: "contained",
        tabIndex: -1,
    },
    cancellationButtonProps: {
        tabIndex: -1,
    },
    dialogProps: {
        maxWidth: "xs",
    },
};
export const CONFIRMATION_DIALOG_ERROR_DEFAULT_OPTIONS = {
    title: "An error occurred",
    confirmationText: "OK",
    confirmationButtonProps: {
        tabIndex: -1,
    },
};
export const IGNORABLE_ERRORS = [
    "AbortError",
    "AxiosError",
    "Failed to fetch",
    "NetworkError when attempting to fetch resource",
    "Non-Error promise rejection captured",
];
export const RDU_FUB_ACCOUNT_ID = 1543900785;
export const INTERNAL_DOMAINS = config.internal_domains;
export default AppConfig;
